import { FC, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

const filterLines = [
  {
    label: "Фамилия",
    name: "surname",
  },
  {
    label: "Имя",
    name: "name",
  }
  // {
  //   label: "Отчество",
  //   name: "patronymic",
  // },
  // {
  //   label: "Отделение",
  //   name: "section",
  // },
  // {
  //   label: "Должность",
  //   name: "workPosition",
  // },
];

const FilterContent: FC<{ onClick: (value: any) => void }> = ({ onClick }) => {
  const [filterValues, setFilterValues] = useState<{
    surname: string;
    name: string;
    // patronymic: string;
    // section: string;
    // workPosition: string;
  }>({ surname: "", name: ""});

  const handleValuesInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFilterValues({ ...filterValues, [name]: value });
  };

  const handleSubmit = () => onClick(filterValues);

  return (
    <Box display="flex" gap={1} paddingRight={1}>
      {filterLines.map(({ label, name }) => (
        <TextField
          key={name}
          label={label}
          variant="outlined"
          onChange={handleValuesInput}
          name={name}
          type="search"
          size='small'
        />
      ))}
      <Button variant="contained" onClick={handleSubmit} size="small">
        Применить
      </Button>
    </Box>
  );
};

export default FilterContent;
